import { tagular } from "@redventures/cohesion-utils-react";

import decodeAndStringifyValue from "@/lib/decode-and-stringify-value";
import { TAGULAR_EVENT_TYPES } from "@/types/tagular";

interface FormContext {
  formBrand?: string;
  formId?: string;
  formName: string;
  formType?: string;
  formVersion?: string;
}

interface StepContext {
  stepId?: string;
  stepName?: string;
  stepNumber?: number;
  stepType?: string;
}

interface FireFieldInputtedOptions {
  autofilled?: boolean;
  fieldId?: string;
  fieldLabel?: string;
  fieldName: string;
  fieldType?: string;
  fieldValue: string;
  fieldSource?: string;
  fieldValueSensitive?: string;
  fieldValueRestricted?: string;
  fieldNumber?: number;
  formContext?: FormContext;
  stepContext?: StepContext;
}

/**
 * Utility: fireFieldInputted
 *
 * Fires when a user blurs (clicks out) of an input field
 * @see {@link https://app.make.rvapps.io/schemas/sch_1LYMqBrN8jTZoBgr1Ort2W9fh4p | FieldInputted Schema}
 */
const fireFieldInputted = (eventOptions: FireFieldInputtedOptions) => {
  const {
    autofilled = false,
    fieldId = "",
    fieldLabel = "",
    fieldName = "",
    fieldType = "",
    fieldValue = "",
    fieldSource = "",
    fieldValueSensitive = "",
    fieldValueRestricted = "",
    fieldNumber,
    formContext,
    stepContext,
  } = eventOptions;

  if (!fieldName && !fieldValue) return;

  const payload: Record<string, unknown> = {
    "@type": TAGULAR_EVENT_TYPES.FIELD_INPUTTED,
    ...(formContext && {
      formContext: {
        ...(formContext.formBrand && {
          formBrand: decodeAndStringifyValue(formContext.formBrand),
        }),
        ...(formContext.formId && {
          formId: decodeAndStringifyValue(formContext.formId),
        }),
        formName: decodeAndStringifyValue(formContext.formName),
        ...(formContext.formType && {
          formType: decodeAndStringifyValue(formContext.formType),
        }),
        ...(formContext.formVersion && {
          formVersion: decodeAndStringifyValue(formContext.formVersion),
        }),
      },
    }),
    ...(stepContext && {
      stepContext: {
        ...(stepContext.stepId && {
          stepId: decodeAndStringifyValue(stepContext.stepId),
        }),
        ...(stepContext.stepName && {
          stepName: decodeAndStringifyValue(stepContext.stepName),
        }),
        ...(stepContext.stepNumber !== undefined && {
          stepNumber: stepContext.stepNumber,
        }),
        ...(stepContext.stepType && {
          stepType: decodeAndStringifyValue(stepContext.stepType),
        }),
      },
    }),
    userInputField: {
      autofilled: Boolean(autofilled),
      ...(fieldId && { fieldId: decodeAndStringifyValue(fieldId) }),
      ...(fieldLabel && { fieldLabel: decodeAndStringifyValue(fieldLabel) }),
      fieldName: decodeAndStringifyValue(fieldName),
      ...(fieldType && { fieldType: decodeAndStringifyValue(fieldType) }),
      fieldValue: decodeAndStringifyValue(fieldValue),
      ...(fieldSource && { fieldSource: decodeAndStringifyValue(fieldSource) }),
      ...(fieldValueSensitive && {
        fieldValueSensitive: decodeAndStringifyValue(fieldValueSensitive),
      }),
      ...(fieldValueRestricted && {
        fieldValueRestricted: decodeAndStringifyValue(fieldValueRestricted),
      }),
      ...(fieldNumber !== undefined && { fieldNumber }),
    },
  };

  tagular("beam", payload);
};

export default fireFieldInputted;
